/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PressReleaseType
 */
export interface PressReleaseType {
    /**
     * release_typ_idに相当
     * @type {string}
     * @memberof PressReleaseType
     */
    id: string;
    /**
     * プレスリリース種類名
     * @type {string}
     * @memberof PressReleaseType
     */
    name: string;
    /**
     * 受信設定がされているかを表すフラグ
     * @type {boolean}
     * @memberof PressReleaseType
     */
    isReceiving: boolean;
}

export function PressReleaseTypeFromJSON(json: any): PressReleaseType {
    return PressReleaseTypeFromJSONTyped(json, false);
}

export function PressReleaseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isReceiving': json['is_receiving'],
    };
}

export function PressReleaseTypeToJSON(value?: PressReleaseType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_receiving': value.isReceiving,
    };
}

